import script from "./MainPermitionsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPermitionsTab.vue?vue&type=script&setup=true&lang=ts"

import "./MainPermitionsTab.vue?vue&type=style&index=0&id=6bc47d79&scoped=true&lang=scss"
import "./MainPermitionsTab.vue?vue&type=style&index=1&id=6bc47d79&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bc47d79"]])

export default __exports__